import { ConsiderRegisterDetailContainer } from "../../containers/RegisterSystem/ConsiderRegisterDetailContainer";
export function ConsiderRegisterDetailPage() {
    return (
        <ConsiderRegisterDetailContainer />
    )
}